import React, {useEffect} from 'react'
import { removeStore, store } from '../../app/store';

export default function Logout() {
  const store_data = JSON.parse(store());
    useEffect(() => {
        removeStore();
        window.location.href= store_data?.role == 'ADMIN' ? "/Admin/Login" : "/Login"
    }, [])
  return (
    <></>
  )
}
